import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { RetouchSection } from './components/RetouchSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { UrgencyCounter } from './components/UrgencyCounter';
import { CtaSection } from './components/CtaSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OrderBump } from './components/OrderBump';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-[#0f0f23] text-white font-sans selection:bg-yellow-500/30" data-id="element-0">
      <main className="max-w-md mx-auto bg-[#13132b] min-h-screen shadow-2xl relative overflow-hidden" data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <RetouchSection data-id="element-5" />
        <BeforeAfterSection data-id="element-6" />
        <VolumesSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <UrgencyCounter data-id="element-9" />
        <CtaSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <OrderBump data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FaqSection data-id="element-14" />
      </main>

      <SocialProofPopup data-id="element-15" />
    </div>;
}